import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadFileBtn from "../Helper/UploadFileBtn/UploadFileBtn";
import { downloadReport, getLastUpdateDateReport, uploadReports } from "./ReportsUtils";
import "./UploadReports.scss";

const DownloadReports = () => {
    const dispatch = useDispatch();
    const [reportType, setReportType] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState(null);

    const reportTypes = [
        { value: 'GET_LEDGER_DETAIL_VIEW_DATA', label: 'Ledger detail view' },
        { value: 'GET_LEDGER_SUMMARY_VIEW_DATA', label: 'Ledger summary view' },
        { value: 'GET_FBA_REIMBURSEMENTS_DATA', label: 'FBA reimbursements' }
    ];

    let defaultAccount = useSelector(
        (state: any) => state.account.default_account
    );

    const handleReportTypeChange = (event) => {
        setReportType(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLastUpdateDate(null);
        const reportName = reportTypes.find(r => r.value === reportType).label;
        await downloadReport(dispatch, defaultAccount.id, reportType, reportName);
        setLastUpdateDate(await getLastUpdateDateReport(
            dispatch, defaultAccount.id, reportType))
    };

    return (
        <div>
            <h2>Download Reports</h2>
            <form style={{ width: "300px" }} onSubmit={handleSubmit}>
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <InputLabel>Select Report Type</InputLabel>
                        <FormControl fullWidth>
                            <Select
                                id="report_type"
                                value={reportType}
                                label="Select Report Type"
                                onChange={handleReportTypeChange}
                                size="medium"
                            >
                                <MenuItem value="">
                                    <em>Select a report type</em>
                                </MenuItem>
                                {reportTypes.map((type) => (
                                    <MenuItem key={type.value} value={type.value}>
                                        {type.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <Button type="submit" className="blue-btn"
                            size="large">
                            Submit
                        </Button>
                    </Grid>
                    {lastUpdateDate && <Grid item xs={12} mt={1}>
                        <p>Last update date: {lastUpdateDate}</p>
                    </Grid>}
                </Grid>
            </form>
        </div>
    );
};

export default DownloadReports;
